
<div class="learnings">
<div class="title">
  <span class="heading">My Learnings  | </span> &nbsp;&nbsp;
  <span>{{data?.length}}  Recent Courses</span>
  <div class="viewall">
      <span (click) = "navigatetoESD()" style="cursor: pointer; font-weight: bold;">View all >></span>
  </div>
</div>
<div class="main-box">
    <div class="main-card" >
        <div class=" first-row"  >
          <div class="scroll-container">
            <div class="card" *ngFor="let item of data?.slice(0,8);" (click) = "navigatetoESDId(item.programID)">
                <div class="image">
                    <img src="assets\images\digital.png" alt="" srcset="">
                </div>
                <div class="video-content">
                  <div>
                    <span id="learning-title" >{{item.programName}}</span>
                  </div>
                  <div class="course-topic">
                    <div class="courses">
                        <span class="material-symbols-outlined" id="learning-sub-title">
                            smart_display
                        </span>
                        <span id="learning-sub-title">{{item.totalCourses}}  courses</span>
                    </div>
                    <div class="topic">
                        <span class="material-symbols-outlined" id="learning-sub-title">
                            assignment
                        </span>
                        <span id="learning-sub-title" style="margin-left: 2px;">{{item.totalTopics}} Topics</span>
                    </div>
                  </div>
                  <div class="course-progress">
                    <div class="icon-course">
                      <span>
                        icon
                      </span>
                      <span style="border: 3px;">
                            -----------
                      </span>
                    </div>
                  </div>
                </div>
              </div>  
            </div>       
        </div>
    </div>
 

</div>
</div>
